import { Observable } from '@apollo/client'
import * as moduleIcons from '@factorialco/f0-react/icons/modules'

// Combines multiple observables into a single observable that emits an array of the latest values from each observable.
// Emits whenever any observable emits a new value.
export function combineLatestObservables<T>(observables: Observable<T>[]): Observable<T[]> {
  return new Observable((observer) => {
    const latestValues: T[] = Array(observables.length).fill(undefined)
    let activeSubscriptions = observables.length

    const subscriptions = observables.map((obs, index) =>
      obs.subscribe({
        next: (value) => {
          latestValues[index] = value
          observer.next([...latestValues]) // Emit a copy of the latestValues array
        },
        error: (err) => observer.error(err),
        complete: () => {
          activeSubscriptions -= 1
          if (activeSubscriptions === 0) {
            observer.complete()
          }
        },
      })
    )

    return () => {
      subscriptions.forEach((sub) => sub.unsubscribe())
    }
  })
}

export type ModuleIcon = keyof typeof moduleIcons

// Convenience function to get the icon for a module while we migrate to
// Factorial One's new icon system.
